import { handleActions } from 'redux-actions';

import { insuranceClaimQuickUpdate, insuranceClaimQuickUpdateSuccess, insuranceClaimQuickUpdateError } from './action';

export interface InsuranceClaimEditModalState {
  isUpdating: boolean;
  lastSuccessClaimableId: number | null;
  lastErrorClaimableId: number | null;
}

const initialState: InsuranceClaimEditModalState = {
  isUpdating: false,
  lastSuccessClaimableId: null,
  lastErrorClaimableId: null,
};

const reducer = handleActions<InsuranceClaimEditModalState>(
  {
    [String(insuranceClaimQuickUpdate)]: (state) => ({
      ...state,
      isUpdating: true,
      lastSuccessClaimableId: null,
      lastErrorClaimableId: null,
    }),
    [String(insuranceClaimQuickUpdateSuccess)]: (state, { payload }) => ({
      ...state,
      isUpdating: false,
      lastSuccessClaimableId: (payload as unknown as { claimableId: number }).claimableId,
      lastErrorClaimableId: null,
    }),
    [String(insuranceClaimQuickUpdateError)]: (state, { payload }) => ({
      ...state,
      isUpdating: false,
      lastSuccessClaimableId: null,
      lastErrorClaimableId: (payload as unknown as { claimableId: number }).claimableId,
    }),
  },
  initialState,
);

export default reducer;
